module.exports = __webpack_public_path__ + "e13a860bf9ab8f815178b60b355abe60.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/hawkin-logo@2x.png
 ** module id = 691
 ** module chunks = 0
 **/